import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
  standardTransition,
} from '../styles';
import { ArrowLink, Link } from './ui';
import { truncateText } from '../utils';

const StyledSalesforceExplainerCard = styled.article`
  border-radius: 10px;
  padding: 30px 20px;
  background-color: ${standardColours.white};
  box-shadow: 0 2px 4px ${standardColours.lighterGrey};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledHeading = styled.h3`
  color: ${brandColours.secondary};
  ${fontSize(18)};
  font-weight: ${fontWeights.semibold};
  transition: ${standardTransition('color')};

  &:hover {
    color: ${brandColours.tertiary};
  }

  ${minBreakpointQuery.small`
    ${fontSize(20)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.xxlarge`
    ${fontSize(24)};
  `}
`;

const StyledSummary = styled.p`
  margin-top: 20px;
  margin-bottom: auto;
  line-height: 1.6;
  ${fontSize(15)};

  ${minBreakpointQuery.small`
    ${fontSize(16)};
  `}
`;

const StyledLinkWrapper = styled.div`
  border-top: solid 1px ${brandColours.secondary};
  padding-top: 20px;
  margin-top: 40px;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}
`;

const SalesforceExplainerCard = salesforceExplainer => {
  const { heading, summary } = salesforceExplainer;

  return (
    <StyledSalesforceExplainerCard>
      <StyledHeading>
        <Link to={salesforceExplainer}>{heading}</Link>
      </StyledHeading>
      <StyledSummary>{truncateText(summary, 180)}</StyledSummary>
      <StyledLinkWrapper>
        <ArrowLink to={salesforceExplainer}>Read more</ArrowLink>
      </StyledLinkWrapper>
    </StyledSalesforceExplainerCard>
  );
};

export default SalesforceExplainerCard;

export const SalesforceExplainerCardFragment = graphql`
  fragment SalesforceExplainerCardFragment on DatoCmsSalesforceExplainer {
    id
    heading: title
    summary
    businessFunctions {
      name
    }
    popularFeatures {
      name
    }
    products {
      name
    }
    ...LinkFragment
  }
`;
